import { createSlotRecipe } from './runtime.js';

const comboboxConfig = {"name":"combobox","slots":["root","control","trigger","clearTrigger","positioner","contentScrollWrapper"],"defaultVariants":{"size":"md"},"variantMap":{"disabled":["true"],"error":["true"],"fullWidth":["true"],"ghost":["true"],"size":["lg","md","sm","xl"],"success":["true"],"warning":["true"]}}

export const combobox = /* @__PURE__ */ createSlotRecipe(comboboxConfig)